import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Importa el nuevo componente NavBarHome
import NavBarHome from './NavBarHome';
import FooterHome from './FooterHome';
import ScrollLogo from './ScrollLogo';
import Product from './Product';
import Soluciones from './Soluciones';
import Servicios from './Servicios';
import Recursos from './Recursos';
import Precios from './Precios';

function HomePage() {
  // Initialize language from localStorage or fallback to 'es'
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'es');

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <div style={styles.container}>
      {/* Usa el componente NavBarHome */}
      <NavBarHome language={language} />

      {/* HEADER */}
      <header style={styles.header}>
        <h1 style={styles.title}>
          {language === 'es'
            ? 'Be there for your team'
            : 'Be there for your team'}
        </h1>
        <p style={styles.subtitle}>
          {language === 'es'
            ? 'Potencia a tu equipo y destaca como manager con herramientas de IA que impulsan el rendimiento.'
            : 'Empower your team and stand out as a manager with AI tools that boost performance.'}
        </p>
        <div style={styles.buttonsContainer}>
          <Link to="/register" style={styles.primaryButton}>
            {language === 'es' ? 'EMPEZAR' : 'GET STARTED'}
          </Link>
          <Link to="/demo" style={styles.secondaryButton}>
            {language === 'es' ? 'Ver demo' : 'View Demo'}
          </Link>
        </div>
      </header>

      {/* SECCIÓN PRINCIPAL (claims) */}
      <section style={styles.claimSection}>
        <h2 style={styles.brandSectionTitle}>
          {language === 'es'
            ? 'Elegido por profesionales de:'
            : 'Trusted by professionals from:'}
        </h2>
        <p style={styles.brandSectionSubtitle}>
          {language === 'es'
            ? 'las empresas más influyentes confían en nuestra herramienta para su desarrollo.'
            : 'top companies that count on our tool to drive their growth.'}
        </p>
        <ScrollLogo />
      </section>

      {/* Sección de Producto */}
      <section id="product">
        <Product language={language} />
      </section>

      {/* Sección de Soluciones */}
      <section id="solutions">
        <Soluciones language={language} />
      </section>

      {/* Sección de Recursos */}
      <section id="resources">
        <Recursos language={language} />
      </section>

      {/* Sección de Servicios */}
      <section id="services">
        <Servicios language={language} />
      </section>

      {/* Sección de Precios */}
      <section id="pricing">
        <Precios language={language} />
      </section>

      {/* FOOTER */}
      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}

// Estilos locales
const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  header: {
    backgroundColor: '#FF2300',
    textAlign: 'center',
    padding: '150px 20px',
    color: '#ffffff',
  },
  title: {
    fontSize: '100px',
    margin: '0 0 5px 0',
    fontWeight: '700',
    fontFamily: "'Helvetica Neue'",
  },
  subtitle: {
    fontSize: '20px',
    margin: '0 0 20px 0',
    fontWeight: '400',
    fontFamily: "'Helvetica Neue'",
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },
  primaryButton: {
    textDecoration: 'none',
    backgroundColor: '#ffffff',
    color: '#FF2300',
    padding: '12px 32px',
    borderRadius: '50px',
    fontWeight: '700',
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
  },
  secondaryButton: {
    textDecoration: 'none',
    color: '#ffffff',
    padding: '12px 32px',
    border: '2px solid #ffffff',
    borderRadius: '50px',
    fontWeight: '400',
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
  },
  claimSection: {
    padding: '30px 20px',
    textAlign: 'center',
    borderBottom: '1px solid #ddd',
  },
  brandSectionTitle: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#ff2300',
    marginBottom: '10px',
  },
  brandSectionSubtitle: {
    fontSize: '18px',
    color: '#555',
    fontWeight: '400',
    marginBottom: '30px',
  },
};

export default HomePage;
